type SiteMetaArg = {
  showWebflowBadge: boolean;
};

type GetWfBadgeStatus = (
  siteMeta?: SiteMetaArg | null | undefined,
  hideBrandingEntitlement?: boolean
) => boolean;

/**
 * Determines whether the Webflow badge should be displayed on a published site.
 * Also used to determine the toggle state of the "Display "Made in Webflow" badge" switch.
 *
 * The badge visibility is determined by the following priority:
 * 1. If `siteMeta.showWebflowBadge` is explicitly defined, use that value
 * 2. If the workspace or site has the entitlement to hide branding, hide the badge
 * 3. Otherwise, default to showing the badge (return true)
 *
 * @param siteMeta - The site's metadata containing the showWebflowBadge preference
 * @param hideBrandingEntitlement - Whether the workspace has the entitlement to hide branding
 * @returns `true` if the Webflow badge should be shown, `false` otherwise
 */
export const getWfBadgeStatus: GetWfBadgeStatus = (
  siteMeta,
  hideBrandingEntitlement
) => {
  if (siteMeta && siteMeta.showWebflowBadge !== undefined) {
    return siteMeta.showWebflowBadge;
  }

  if (hideBrandingEntitlement) {
    return false;
  }

  return true;
};

type PublishTask = {
  POLLING_INTERVAL: number;
  POLLING_TIMEOUT: number;
  MAX_POLL_RETRIES: number;
};

const POLLING_INTERVAL = 1500;
const POLLING_TIMEOUT = 60 * 60 * 1000;
export const PUBLISH_TASK: PublishTask = {
  POLLING_INTERVAL,
  POLLING_TIMEOUT,
  MAX_POLL_RETRIES: Math.floor(POLLING_TIMEOUT / POLLING_INTERVAL),
};
